import React from 'react';

function Mantenimiento() {
  return <div>Registrar Negocio</div>;
}

export default Mantenimiento;
